// extracted by mini-css-extract-plugin
export default {"table":"arp_9","tr":"xKcAK","td":"GRv5m","row":"wtP5b","rowTitle":"Z4hCl","rowDescription":"GU6A_","cellTitle":"RaL4q","cellDescription":"vHTNV"};